import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=bc5a08d6&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=bc5a08d6&prod&lang=scss"
import style1 from "./Home.vue?vue&type=style&index=1&id=bc5a08d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5a08d6",
  null
  
)

export default component.exports